module.exports = __webpack_public_path__ + "img/checkmark.9745e77b.png";